import React, { useState } from 'react'
import {
  getGuestCartContents,
  removeGuestCartItem,
  addGuestCartItem,
  updateGuestCartItemQuantity,
  GuestOrder
} from '#src/services/cart'

export interface GuestCartContextType {
  data?: {
    order: GuestOrder
    syncOrder: () => GuestOrder
    removeGuestCartItem: (sellableId: string) => void
    updateGuestCartItemQuantity: (sellableId: string, quantity: number) => void
    addGuestCartItem: (sellableId: string) => void
  }
}

const GuestCartContext = React.createContext<GuestCartContextType>({
  data: {
    order: getGuestCartContents(),
    syncOrder: () => getGuestCartContents(),
    removeGuestCartItem: () => null,
    addGuestCartItem: () => null,
    updateGuestCartItemQuantity: () => null
  }
})

const GuestCartConsumer = GuestCartContext.Consumer

interface GuestCartObserverProps {}

const GuestCartObserver: React.FC<GuestCartObserverProps> = ({ children }) => {
  if (process.env.TARGET === 'node') {
    return <>{children}</>
  }

  const [guestCartContents, setGuestCartContents] = useState(getGuestCartContents())
  const syncOrder = () => {
    setGuestCartContents(getGuestCartContents())

    return guestCartContents
  }

  return (
    <GuestCartContext.Provider
      value={{
        data: {
          order: guestCartContents,
          addGuestCartItem: sellableId => {
            addGuestCartItem(sellableId)
            syncOrder()
          },
          removeGuestCartItem: sellableId => {
            removeGuestCartItem(sellableId)
            syncOrder()
          },
          updateGuestCartItemQuantity: (sellableId, quantity) => {
            updateGuestCartItemQuantity(sellableId, quantity)
            syncOrder()
          },
          syncOrder
        }
      }}
    >
      {children}
    </GuestCartContext.Provider>
  )
}

export default GuestCartObserver
export { GuestCartContext, GuestCartConsumer }
